import ProductStockTransfersHtml from './product.stock-transfers.html';

export function ProductStockTransfersDirective () {
  return {
    controller: 'ProductStockTransfersCtrl',
    restrict: 'E',
    templateUrl: ProductStockTransfersHtml,
    scope: {
      transfers: '=',
      product: '='
    }
  }
};